import React, { lazy } from 'react';
import { GiftIcon } from 'lucide-react';
const bonuses = [{
  number: 1,
  title: 'Your 15-Minute Natural First Aid Kit',
  description: "A 1-page action checklist + 9-minute audio walkthrough: the 5 remedies you can make RIGHT NOW with what's already in your kitchen. Zero new purchases. Your emergency kit, ready before bedtime tonight.",
  regularPrice: 37,
  image: 'https://cdn.magicpatterns.com/uploads/jgeM1FGf3WtS3X1eGNFfVC/bono_1_ancestral.jpg'
}, {
  number: 2,
  title: 'The Remedy Cheat Sheet: 60 Symptoms → Exactly What To Do',
  description: "A printable fridge card + phone wallpaper version. Two columns: symptom on the left, remedy + dose + time on the right. Stick it on your fridge. When someone gets sick, you don't think — you just look.",
  regularPrice: 47,
  image: 'https://cdn.magicpatterns.com/uploads/tLSuaja6QUZzU5kCqnSWvK/bono_2_ancesral.jpg'
}, {
  number: 3,
  title: 'The Consistency Code',
  description: 'The 3-week habit integration system that turns this from "another thing I bought" into your family\'s actual health routine. Includes the 3 mental blocks that stop most women cold — and exactly how to break each one.',
  regularPrice: 37,
  image: 'https://cdn.magicpatterns.com/uploads/dmCN73xDmaKHgTndYVQMym/bono_3_ancestral.jpg'
}, {
  number: 4,
  title: 'The $40 Holistic Pantry',
  description: "The 12 grocery-store staples (ginger, turmeric, raw honey, garlic, and more) that cover 80% of your family's common ailments — all available at any supermarket for under $40 total. Includes a ready-to-print shopping list.",
  regularPrice: 47,
  image: 'https://cdn.magicpatterns.com/uploads/wWq78wRss71KwnyMQvTfpC/bono_4_ancestral.jpg'
}, {
  number: 5,
  title: 'Beyond The Basics Masterclass',
  description: 'A 50-minute video masterclass + companion guide for when the handbook feels too easy. How to make tinctures and salves from scratch, build a real home apothecary, and what to study next if you want to go deeper.',
  regularPrice: 97,
  image: 'https://cdn.magicpatterns.com/uploads/7pjJN3YWKSMzvAUrrPHM64/bono_5_ancestral.jpg'
}];
export function BonusSection() {
  const totalBonusValue = bonuses.reduce((sum, bonus) => sum + bonus.regularPrice, 0);
  return <section className="py-8 md:py-16" data-id="element-36">
      <div className="max-w-5xl mx-auto px-4" data-id="element-37">
        {/* Header */}
        <div className="text-center mb-4 md:mb-6" data-id="element-38">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gold/20 rounded-full mb-3 md:mb-4 shadow-inner" data-id="element-39">
            <GiftIcon className="w-8 h-8 text-gold" data-id="element-40" />
          </div>
          <h2 className="font-heading text-4xl md:text-5xl font-bold mb-3 md:mb-4" data-id="element-41">
            <span className="text-dark" data-id="element-42">CLAIM YOUR 5 </span>
            <span className="text-primary" data-id="element-43">FREE BONUSES</span>
          </h2>
          <p className="text-xl md:text-2xl text-dark font-medium max-w-2xl mx-auto leading-relaxed" data-id="element-44">
            Over{' '}
            <span className="text-solution font-bold" data-id="element-45">${totalBonusValue}</span>{' '}
            in bonuses — yours{' '}
            <span className="text-solution font-black bg-solution/10 px-2 py-1 rounded" data-id="element-46">
              FREE
            </span>{' '}
            when you order today.
          </p>
          <div className="mx-auto mt-4 md:mt-6 mb-2 w-24 h-1 rounded-full bg-primary/40" data-id="element-47"></div>
        </div>

        {/* Bonuses List */}
        <div className="space-y-4 md:space-y-8 mt-5 md:mt-8" data-id="element-48">
          {bonuses.map(bonus => {
          const isOdd = bonus.number % 2 !== 0;
          const bgClass = isOdd ? 'bg-cream' : 'bg-white';
          return <div key={bonus.number} className={`${bgClass} rounded-2xl shadow-lg overflow-hidden border border-gray-100`} data-id="element-49">
                <div className={`flex flex-col ${isOdd ? 'md:flex-row' : 'md:flex-row-reverse'} group`} data-id="element-50">
                  {/* Image */}
                  <div className="relative w-full md:w-2/5 h-56 md:h-auto md:min-h-[260px] bg-gold-light/20 overflow-hidden flex-shrink-0" data-id="element-51">
                    {bonus.image ? <img src={bonus.image} alt={bonus.title} className="absolute inset-0 w-full h-full object-cover object-center scale-110 transform group-hover:scale-[1.15] transition-transform duration-700" loading="lazy" data-id="element-52" /> : <div className="absolute inset-0 flex items-center justify-center bg-gold/10" data-id="element-53">
                        <span className="text-gold font-bold text-4xl" data-id="element-54">
                          #{bonus.number}
                        </span>
                      </div>}

                    {/* Badges */}
                    <div className="absolute top-4 right-4 bg-solution text-white font-black text-sm tracking-wider px-4 py-1.5 rounded-full shadow-lg transform rotate-3 border-2 border-white z-10" data-id="element-55">
                      FREE TODAY
                    </div>
                    <div className="absolute bottom-4 left-4 bg-dark/80 backdrop-blur-sm text-white text-sm font-medium px-3 py-1.5 rounded-full shadow-md z-10" data-id="element-56">
                      Value: ${bonus.regularPrice}
                    </div>
                  </div>

                  {/* Text */}
                  <div className="w-full md:w-3/5 p-4 md:p-6 lg:p-8 flex flex-col justify-center" data-id="element-57">
                    <p className="text-primary font-bold text-xs uppercase tracking-widest mb-2 md:mb-4" data-id="element-58">
                      Bonus #{bonus.number}
                    </p>

                    <h3 className="font-heading text-2xl md:text-3xl font-bold text-dark mb-2 md:mb-4 leading-tight" data-id="element-59">
                      {bonus.title}
                    </h3>

                    <p className="text-muted text-base md:text-lg leading-relaxed mb-3 md:mb-5 flex-grow" data-id="element-60">
                      {bonus.description}
                    </p>

                    <div className="mt-auto pt-3 md:pt-5 border-t border-gray-100 flex items-center flex-wrap gap-3" data-id="element-61">
                      <span className="text-muted font-medium" data-id="element-62">
                        Regular Price:
                      </span>
                      <span className="text-xl text-gray-400 line-through font-bold" data-id="element-63">
                        ${bonus.regularPrice}
                      </span>
                      <span className="text-xl text-primary font-black ml-1" data-id="element-64">
                        — YOURS FREE
                      </span>
                    </div>
                  </div>
                </div>
              </div>;
        })}
        </div>

        {/* Total Value Box */}
        <div className="mt-6 md:mt-10 bg-white border-4 border-gold rounded-3xl p-5 md:p-8 shadow-2xl relative overflow-hidden text-center" data-id="element-65">
          <div className="absolute top-0 left-0 w-full h-3 bg-gradient-to-r from-gold-light via-gold to-gold-light" data-id="element-66"></div>

          <h3 className="font-heading text-2xl md:text-3xl font-bold text-dark mb-3 md:mb-5 uppercase tracking-wide" data-id="element-67">
            Total Stack Value
          </h3>

          <div className="mb-3 md:mb-4" data-id="element-68">
            <span className="text-5xl md:text-6xl font-black text-gray-300 line-through decoration-4" data-id="element-69">
              $362
            </span>
          </div>

          <p className="text-sm uppercase tracking-wider text-muted mb-2" data-id="element-70">
            Your Price Today
          </p>
          <span className="text-6xl md:text-7xl font-black text-primary" data-id="element-71">
            $27
          </span>

          <p className="text-muted text-base md:text-lg mt-3 md:mt-4 mb-3 md:mb-4" data-id="element-72">
            You save $335 — that's a 92% discount.
          </p>

          <div className="inline-block bg-gold/10 border border-gold/30 rounded-lg px-6 py-3 mt-3 md:mt-4" data-id="element-73">
            <p className="text-dark text-sm md:text-base uppercase tracking-wider font-bold flex items-center justify-center gap-2" data-id="element-74">
              <span className="text-xl" data-id="element-75">⏱️</span> This bonus package is only
              available during our current launch window.
            </p>
          </div>
        </div>
      </div>
    </section>;
}